module.exports = __webpack_public_path__ + "static/media/settings.a22f5472.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Media/settings.svg
// module id = 29
// module chunks = 0